import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvcQuoteComponent } from './pages/evc-quote/evc-quote.component';
import { EvcQuoteRoutingModule } from './evc-quote-routing.module';
import { IntroComponent } from './components/intro/intro.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { CarDetailsComponent } from './components/car-details/car-details.component';
import { ChargingStationDetailsComponent } from './components/charging-station-details/charging-station-details.component';
import { TechnicalDetailsComponent } from './components/technical-details/technical-details.component';
import { HouseDetailsComponent } from './components/house-details/house-details.component';
import { PersonalDetailsComponent } from './components/personal-details/personal-details.component';
import { ChargingStationPlacementComponent } from './components/charging-station-details/components/charging-station-placement/charging-station-placement.component';
import { AnalyticsModule } from '../../shared/modules/analytics/analytics.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ChargingStationAccessBadgeComponent } from './components/charging-station-details/components/charging-station-access-badge/charging-station-access-badge.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { FuseBoxComponent } from './components/technical-details/components/fuse-box/fuse-box.component';
import { ElectricPhaseComponent } from './components/technical-details/components/electric-phase/electric-phase.component';
import { AmperageComponent } from './components/technical-details/components/amperage/amperage.component';
import { MainFuseComponent } from './components/technical-details/components/main-fuse/main-fuse.component';
import { DistanceComponent } from './components/technical-details/components/distance/distance.component';
import { TrajectoryComponent } from './components/technical-details/components/trajectory/trajectory.component';
import { PlacementComponent } from './components/technical-details/components/placement/placement.component';
import { TechnicalDetailsIntroComponent } from './components/technical-details/components/technical-details-intro/technical-details-intro.component';
import { HouseAgeComponent } from './components/house-details/components/house-age/house-age.component';
import { HouseTypeComponent } from './components/house-details/components/house-type/house-type.component';
import { SolarPanelsComponent } from './components/house-details/components/solar-panels/solar-panels.component';
import { ProfessionalComponent } from './components/personal-details/components/professional/professional.component';
import { ContactDetailsComponent } from './components/personal-details/components/contact-details/contact-details.component';
import { NewsletterOptInComponent } from './components/personal-details/components/newsletter-opt-in/newsletter-opt-in.component';
import { RemarksComponent } from './components/personal-details/components/remarks/remarks.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ToastrModule } from 'ngx-toastr';
import { ContinueLaterComponent } from './components/technical-details/components/continue-later/continue-later.component';
import { SummaryComponent } from './components/car-details/components/summary/summary.component';
import { GoogleAutocompleteComponent } from '../../shared/IFE/components/google-autocomplete/google-autocomplete.component';
import { MultipleImagePickerComponent } from './components/technical-details/components/multiple-image-picker/multiple-image-picker.component';
import { ExistingClientQuoteComponent } from './components/personal-details/components/existing-client/existing-client-quote.component';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { DirectivesModule } from '@app/shared/directives/directives.module';

@NgModule({
  declarations: [
    EvcQuoteComponent,
    IntroComponent,
    CarDetailsComponent,
    ChargingStationDetailsComponent,
    TechnicalDetailsComponent,
    HouseDetailsComponent,
    PersonalDetailsComponent,
    ChargingStationPlacementComponent,
    ChargingStationAccessBadgeComponent,
    ConfirmationComponent,
    FuseBoxComponent,
    ElectricPhaseComponent,
    AmperageComponent,
    MainFuseComponent,
    DistanceComponent,
    TrajectoryComponent,
    PlacementComponent,
    TechnicalDetailsIntroComponent,
    HouseAgeComponent,
    HouseTypeComponent,
    SolarPanelsComponent,
    ProfessionalComponent,
    ContactDetailsComponent,
    NewsletterOptInComponent,
    RemarksComponent,
    ContinueLaterComponent,
    SummaryComponent,
    GoogleAutocompleteComponent,
    MultipleImagePickerComponent,
    ExistingClientQuoteComponent,
  ],
  imports: [
    CommonModule,
    EvcQuoteRoutingModule,
    SharedModule,
    TranslateModule,
    AnalyticsModule,
    ReactiveFormsModule,
    QRCodeModule,
    ToastrModule.forRoot({
      progressBar: true,
      progressAnimation: 'increasing',
    }),
    DirectivesModule
  ],
  providers: [TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EvcQuoteModule {}

// Add translation markers.
_('modules.evcQuote.general.title');
_('modules.evcQuote.steps.intro.steps.step1');
_('modules.evcQuote.steps.intro.steps.step2');
_('modules.evcQuote.steps.intro.steps.step3');
_('modules.evcQuote.steps.intro.steps.step4');
_('modules.evcQuote.steps.intro.steps.step5');
_('modules.evcQuote.steps.houseDetails.stepName');
_('modules.evcQuote.steps.carDetails.fields.carDetails.carBrand.label');
_('modules.evcQuote.steps.carDetails.fields.carDetails.carBrand.placeholder');
_('modules.evcQuote.steps.technicalDetails.steps.trajectory.imageTake.image1');
_('modules.evcQuote.steps.technicalDetails.steps.trajectory.imageSelect.image1');
_('modules.evcQuote.steps.technicalDetails.steps.trajectory.imageTake.image2');
_('modules.evcQuote.steps.technicalDetails.steps.trajectory.imageSelect.image2');
_('modules.evcQuote.steps.technicalDetails.steps.trajectory.imageTake.image3');
_('modules.evcQuote.steps.technicalDetails.steps.trajectory.imageSelect.image3');
